<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup">
  <div *ngIf="!hideLabel" class="label d-flex justify-content-between">
    <span>
      {{ 'CLIENT_SELECT.CLIENT' | translate }}
    </span>

    <span *ngIf="parentFormGroup.get(passFormControlName).value">
      <button type="button" class="btn btn-ico btn-link" (click)="edit()">
        <i class="fal fa-pencil"></i>
      </button>
    </span>
  </div>

  <ng-container *ngIf="isInModal; else outsideModal">
    <ng-select
      [items]="data | async"
      bindLabel="name"
      bindValue="id"
      [loading]="loader"
      [formControlName]="passFormControlName"
      [typeahead]="input$"
      (change)="onChange($event)"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div class="client-select-option-wrapper">
          <div class="client-name">
            <span
              *ngIf="item?.country && item?.country?.code"
              class="flag-icon"
              [ngClass]="'flag-icon-' + (item?.country?.code | lowercase)"
            ></span>

            {{ item.name }}
          </div>
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'CLIENT_SELECT.ADD' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </ng-container>

  <ng-template #outsideModal>
    <ng-select
      [items]="data | async"
      bindLabel="name"
      bindValue="id"
      [loading]="loader"
      [formControlName]="passFormControlName"
      appendTo="body"
      [typeahead]="input$"
      (change)="onChange($event)"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div class="client-select-option-wrapper">
          <div class="client-name">
            <span
              *ngIf="item?.country && item?.country?.code"
              class="flag-icon"
              [ngClass]="'flag-icon-' + (item?.country?.code | lowercase)"
            ></span>

            {{ item.name }}
          </div>
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'CLIENT_SELECT.ADD' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </ng-template>
</div>
